<template>
  <el-form class="justify-label" :model="formData" :rules="rules" :ref="formRefName" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="16">
        <el-form-item label="企业名称：" prop="entName">
          <el-autocomplete class="evaluation inline-input" v-model.trim="formData.entName" :fetch-suggestions="querySearch" value-key="name"
            placeholder="请输入并选择企业名称" :trigger-on-focus="false" :debounce="500" @blur="handleBlur" @select="handleSelect"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="注册日期：" prop="regDate">
          <el-date-picker style="width: 100%;" v-model="formData.regDate" type="date" placeholder="请选择企业注册日期" value-format="yyyy-MM-dd" />
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item label="社信代码：" prop="uniteCode">
          <div style="width: 50%;">
            <el-input v-model="formData.uniteCode" placeholder="请输入企业社信代码" />
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="法定代表人：" prop="corporate">
          <el-input v-model="formData.corporate" placeholder="请输入企业法定代表人" />
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item label="所属地区：">
          <div class="u-flex">
            <div class="u-flex-1">
              <el-form-item prop="provinceCode">
                <el-select v-model="formData.provinceCode" placeholder="请选择省份" @change="handleProvince">
                  <el-option v-for="item in provinceTree" :key="item.districtCode" :label="item.districtName" :value="item.districtCode" />
                </el-select>
              </el-form-item>
            </div>
            <div class="u-flex-1" style="margin: 0 10px;">
              <el-form-item prop="cityCode">
                <el-select v-model="formData.cityCode" placeholder="请选择州市" @change="handleCity">
                  <el-option v-for="item in cityTree" :key="item.districtCode" :label="item.districtName" :value="item.districtCode" />
                </el-select>
              </el-form-item>
            </div>
            <div class="u-flex-1">
              <el-form-item prop="districtCode">
                <el-select v-model="formData.districtCode" placeholder="请选择区县">
                  <el-option v-for="item in districtTree" :key="item.districtCode" :label="item.districtName" :value="item.districtCode" />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="所属行业：" prop="industryCode">
          <el-cascader style="width: 100%;" ref="cascader" v-model="formData.industryCode" placeholder="请选择企业所属行业" :options="industryList" :props="cascaderProps"
            filterable collapse-tags clearable @change="handleIndustry">
            <template slot="empty">
              <div class="u-p-20 t-g">暂无相关行业选项</div>
            </template>
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="注册地址：" prop="regAddress">
          <el-input type="textarea" v-model="formData.regAddress" placeholder="请输入企业注册地址" :autosize="{ minRows: 2, maxRows: 4}" />
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="domain">
        <el-form-item label="技术领域：" required>
          <div class="u-flex">
            <div style="width: 33%;">
              <el-form-item prop="domainLevelOneCode">
                <el-select class="evaluation" style="width: 100%;" v-model="formData.domainLevelOneCode" placeholder="请选择技术领域(一级)" @change="handleDomainLevelOne">
                  <el-option v-for="item in domainLevelOne" :key="item.domainCode" :label="item.domainName" :value="item.domainCode" />
                </el-select>
              </el-form-item>
            </div>
            <div style="width: 33%; margin: 0 10px;">
              <el-form-item prop="domainLevelTwoCode">
                <el-select class="evaluation" style="width: 100%;" v-model="formData.domainLevelTwoCode" placeholder="请选择技术领域(二级)" @change="handleDomainLevelTwo">
                  <el-option v-for="item in domainLevelTwo" :key="item.domainCode" :label="item.domainName" :value="item.domainCode" />
                </el-select>
              </el-form-item>
            </div>
            <div style="width: 33%;" v-if="showDomainLevelThree">
              <el-form-item prop="domainLevelThreeCode">
                <el-select class="evaluation" style="width: 100%;" v-model="formData.domainLevelThreeCode" placeholder="请选择技术领域(三级)">
                  <el-option v-for="item in domainLevelThree" :key="item.domainCode" :label="item.domainName" :value="item.domainCode" />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item label="申报联系人：" prop="contactName">
          <div style="width: 50%;">
            <el-input class="evaluation" v-model="formData.contactName" placeholder="请输入申报联系人" />
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="联系手机：" prop="contactMobile">
          <el-input class="evaluation" v-model="formData.contactMobile" placeholder="请输入联系手机" maxlength="11" show-word-limit />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { reqEnterpriseList } from '@/api/dictAPI';
import { mapGetters } from 'vuex';
export default {
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    industryList: {
      type: Array,
      default: () => {
        return []
      }
    },
    provinceTree: {
      type: Array,
      default: () => {
        return []
      }
    },
    cityTree: {
      type: Array,
      default: () => {
        return []
      }
    },
    districtTree: {
      type: Array,
      default: () => {
        return []
      }
    },
    _disabled: {
      type: Boolean,
      default: false
    },
    entNameDisabled: {
      type: Boolean,
      default: false
    },
    domainLevelOne: {
      type: Array,
      default: () => {
        return []
      }
    },
    domainLevelTwo: {
      type: Array,
      default: () => {
        return []
      }
    },
    domainLevelThree: {
      type: Array,
      default: () => {
        return []
      }
    },
    domain: {
      type: Boolean,
      default: false
    },
    showDomainLevelThree: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var validateMobile = async (rule, value, callback) => {
      const regExp = new RegExp(/^1[3-9]\d{9}$/);
      if (!value) {
        callback(new Error("请输入联系手机"));
      } else if (regExp.test(value)) {
        callback();
      } else {
        callback(new Error("手机号码格式不正确"));
      }
    }
    var validateUniteCode = async (rule, value, callback) => {
      const regExp = new RegExp(/^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/);
      if (!value || regExp.test(value)) {
        callback();
      } else {
        callback(new Error("社信代码格式不正确"));
      }
    }
    return {
      cascaderProps: {
        checkStrictly: true,
        emitPath: false,
        value: 'industryCode',
        label: 'industryName',
        children: 'child'
      },
      isSelected: false,
      restaurants: [],
      formRefName: 'ruleForm',
      // 
      rules: {
        entName: [{ required: true, message: '请输入并选择企业名称', trigger: ['blur', 'change'] }],
        uniteCode: [{ required: false, validator: validateUniteCode, trigger: 'blur' }],
        contactName: [{ required: true, message: '请输入申报联系人', trigger: 'blur' }],
        contactMobile: [{ required: true, validator: validateMobile, trigger: 'blur' }],
        domainLevelOneCode: [{ required: true, message: '请选择技术领域一级', trigger: ['blur', 'change'] }],
        domainLevelTwoCode: [{ required: true, message: '请选择技术领域二级', trigger: ['blur', 'change'] }],
        domainLevelThreeCode: [{ required: true, message: '请选择技术领域三级', trigger: ['blur', 'change'] }],
      }
    }
  },
  computed: {
    ...mapGetters('personOptions', ['_enterpriseDisable', '_isLogin', '_enterpriseDisable'])
  },
  methods: {
    handleProvince(code) {
      this.$emit('handleProvince', code);
    },
    handleCity(code) {
      this.$emit('handleCity', code);
    },
    handleDomainLevelOne(code) {
      this.$emit('handleDomainLevelOne', code);
    },
    handleDomainLevelTwo(code) {
      this.$emit('handleDomainLevelTwo', code);
    },
    async querySearch(queryString, cb) {
      this.isSelected = false;
      const resp = await reqEnterpriseList(queryString);
      if (resp.result) {
        this.restaurants = resp.data && resp.data.length ? resp.data.map(item => ({name: item})) : [];
      } else {
        this.restaurants = [];
      }
      const restaurants = this.restaurants;
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    handleBlur() {
      if (!this.isSelected && this.restaurants.length) {
        this.$emit('clearEntName');
      }
    },
    // 选择企业
    handleSelect({ name }) {
      this.isSelected = true;
      this.$refs[this.formRefName].resetFields();
      this.$emit('handleSelect', name);
    },
    handleIndustry() {
      const _result = this.$refs['cascader'].getCheckedNodes()[0];
      const industry = _result ? _result.label : '';
      this.$emit('handleIndustry', industry);
    },
    submitForm() {
      this.$refs[this.formRefName].validate((valid) => {
        if (valid) {
          this.$emit('toEvaluation');
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.inline-input {
  width: 100%;
}
</style>